import { useCallback } from 'react';
import { authContinue } from '../utils/authUtils';

export function useProgressiveRegistrationRedirect() {
  const redirect = useCallback(async () => {
    await window.auth.clearUser();
    authContinue();
  }, []);
  return { redirect };
}
